import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';
import { Observable } from 'rxjs';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { TranslationText } from '../entities/translation-text';

@Injectable()
export class TranslationTextService extends BaseCrudService<TranslationText> {

  public uri = '/api/translationText/';

  constructor(injector: Injector) {
      super(injector);
     //console.log('Instance TerminationReasonService');
  }

  buildSentence(entity?: TranslationText, event?: LazyLoadEvent): HttpParams {
      if (entity) {
          let query = entity.code ? 'code'
              + QueryOperator.Contain + entity.code
              + QueryOperator.Split : QueryOperator.Empty;
          query = query.concat(
              entity.name ? 'name'
              + QueryOperator.Contain + entity.name
              + QueryOperator.Split : QueryOperator.Empty
          );
          query = query.concat(
            entity.source ? 'source.id'
            + QueryOperator.Equal + entity.source.id
            + QueryOperator.Split : QueryOperator.Empty
        );
          this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
      }

      if (event) {
          const page = ((event.first + event.rows) / event.rows - 1 ).toString();
          const size = event.rows.toString();
          this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
          this.httpParams =  this.httpParams.set(QueryOperator.SizeParam, size);
      }
      return this.httpParams;
  }

  getTranslation(user_id : number):Observable<any>{    
      this.rutaServidor = localStorage.getItem('rutaServidor');
    const url = `${this.rutaServidor}${this.uri}getTranslation`; 
    //console.log("url :" + url);
    this.spinnerService.showAll();
    return this.httpClient.get(url + "?user_id=" + user_id );
}


}



// WEBPACK FOOTER //
// ./src/app/core/services/translation-text.service.ts